module.exports = __webpack_public_path__ + "static/media/googlePin9.dd50f189.svg";